module.exports = "/images/blank_thumb.png?217ed177a3f4246230696bc0f60830f3";